import amplitude from 'amplitude-js';
import { masterEvents } from 'constantes';

// Licencia de amplitud
const API_KEY_AMPLITUDE = process.env.REACT_APP_BASE_LICENSE_KEY_AMPLITUDE;

export class AnalyticsAmplitud {
    /**
     * @name instancieAmplitude
     * @desc Metodo que inicia el servidor de amplitude para la comunicación
     * @param username
     */
    static instancieAmplitude(username) {
        const amp = amplitude.getInstance();
        amp.init(API_KEY_AMPLITUDE, null, {
            includeUtm: true,
            includeGclid: true,
            includeReferrer: true,
        });
        amp.setUserId(username);
        amp.logEvent(masterEvents.EVENTO_INICIO_SESION);
    }

    static registerEvent(eventName) {
        const amp = amplitude.getInstance();
        amp.logEvent(eventName);
    }
}
